import React, { Component } from 'react'
import Panel from '../Panel'

class AppointmentCard extends Component {
  render() {
    const { item } = this.props
    const { appointment_card = {} } = item

    return (
      <Panel
        icon="//qnm.hunliji.com/o_1d8n7rbpg1d2jvpdt73i2l1qi4j.png"
        item={item}
      >
        {!!appointment_card.source && (
          <div className="item">
            <span>渠道&nbsp;:&nbsp;</span>
            <span>{appointment_card.source}</span>
          </div>
        )}
        {!!appointment_card.appointment_type && (
          <div className="item">
            <span>预约来源&nbsp;:&nbsp;</span>
            <span>{appointment_card.appointment_type}</span>
          </div>
        )}
      </Panel>
    )
  }
}

export default AppointmentCard
